import { PATHS } from "../../utils/routes";

export const SESSION_PHASES = Object.freeze({
  anonymous: "anonymous",
  redirecting: "redirecting",
  callbackProcessing: "callback_processing",
  bootstrappingProfile: "bootstrapping_profile",
  verificationRequired: "verification_required",
  ready: "ready",
  recoveryRequired: "recovery_required",
  hardError: "hard_error",
});

export const SESSION_BLOCKING_REASONS = Object.freeze({
  backendWakeup: "backend_wakeup",
  invalidState: "invalid_state",
  loginRequired: "login_required",
  consentRequired: "consent_required",
  interactionRequired: "interaction_required",
  invalidGrant: "invalid_grant",
  sessionExpired: "session_expired",
  missingRefreshToken: "missing_refresh_token",
  emailUnverified: "email_unverified",
  previewOriginBlocked: "preview_origin_blocked",
  accessDenied: "access_denied",
  unknown: "unknown",
});

export const SESSION_ACTION_TYPES = Object.freeze({
  loginStarted: "session/login-started",
  callbackStarted: "session/callback-started",
  callbackTokensReady: "session/callback-tokens-ready",
  profileBootstrapStarted: "session/profile-bootstrap-started",
  profileBootstrapResolved: "session/profile-bootstrap-resolved",
  recoveryRequested: "session/recovery-requested",
  bootstrapRetried: "session/bootstrap-retried",
  hardErrorRaised: "session/hard-error-raised",
  errorAcknowledged: "session/error-acknowledged",
  verificationRequired: "session/verification-required",
});

export const DEFAULT_SESSION_TARGET_PATH = PATHS.root;

export const isKnownSessionPhase = (value) =>
  Object.values(SESSION_PHASES).includes(value);

export const isKnownBlockingReason = (value) =>
  value == null || Object.values(SESSION_BLOCKING_REASONS).includes(value);
